import React from 'react';
import { Toast,Button,Modal,Space } from 'antd-mobile';
import {post} from '../utils/request';
import api from './api';

import './index.less';
import classnames from 'classnames';

function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
      if (matchesSelector.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

class InterestsConfig extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            urlOps: {},
            detail:{},//权益配置详情
            hcCustInterestsConfigId:'',//用户权益配置id

            modal: false,
        }
    }
    componentDidMount(){

        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                Toast.fail('请登录APP再进行操作',999);
                return;
            }
            
            this.setState({
                urlOps: ops
            },()=>{
                if(ops.app_stoken && ops.app_stoken != 'null'){
                    this.selectCustInterestsConfig();
                }
            });
        }
        
    }
    applyHcWelfareConsume=()=>{  
        const {urlOps} = this.state;
        const { detail } = this.state;
        post({ 
            url:api.applyHcWelfareConsume + '?app_stoken=' + urlOps.app_stoken,
            data: {
                interestsCode: detail.interestsCode,
                interestsName: detail.interestsName
        } }).then((res) => {
            if(res.result === 'success'){
                this.selectCustInterestsConfig();
            };
            this.setState({
                modal: false,
            });
            Toast.info(res.msg,1);

        },(res)=>{
            this.setState({
                modal: false,
            });
            Toast.info(res.msg,1);
        });

    }
    selectCustInterestsConfig= () => {
        const {urlOps} = this.state;

        post({ 
            url:api.myInterests + '?app_stoken=' + urlOps.app_stoken,
            data: {
            interestsCode: urlOps.interestsCode,
        } }).then((res) => {
            if(res.result === 'success'){
                this.setState({
                    detail: res.data[0],
                });
            }else{
                Toast.info(res.msg,1);
            }

        },(res)=>{
            Toast.info(res.msg,1);
        });
    }
    onWrapTouchStart(e) {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
        return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
        e.preventDefault();
        }
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }

    appCharging(){
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                window.webkit.messageHandlers.charging.postMessage('1');
            }
        } else {
            if(window.huilian){
                window.huilian.charging('1');
            }
        }
    }
    appViolations() {
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                window.webkit.messageHandlers.violations.postMessage('1');
            }
        } else {
            if(window.huilian){
                window.huilian.violations('1');
            }
        }
    }

    render() {
        const {
            detail,
        } = this.state;

        return (
            <div className="page_type_h5">
                <div id="interestsConfig" className='interestsConfig'>
                    {
                        detail ? (
                            <div>
                                <div className='head-box'>
                                    <img src={detail.advertiseAccessory} />
                                
                                    {/* <h1>{detail.interestsName}</h1>
                                    <h2>{detail.interestsDigest}</h2> */}
                                </div>
                                <div className='content-box'>
                                    <div className='content-times'>次数：<span>{detail.interestsTimes!=null && detail.interestsTimes >= 0 ? detail.interestsTimes:'不限次数'}</span>
                                    <span className='content-surplus'>{ detail.surplusTimes!=null && detail.surplusTimes >= 0 ? `剩余：${detail.surplusTimes}次` : ''}</span></div>
                                    <div className='content-title'>权益说明：</div>
                                    <div className='content-rules' dangerouslySetInnerHTML={{__html:detail.interestsRules}}>
                                        {/* {detail.interestsRules} */}
                                    </div>
                                </div>
                                {
                                    detail.manualVerify == '1' && detail.interestsName!='免费充电' ? (
                                        <div className='content-button'>
                                            <Button className={
                                                classnames('button-box',{'button-box-disabled':detail.surplusTimes == 0})
                                            }
                                                onClick={()=>{
                                                    if( detail.surplusTimes == 0 ){
                                                        return
                                                    }else{
                                                        this.setState({
                                                            modal: true,
                                                        });
                                                    }
                                                }}>
                                                马上发起
                                            </Button>
                                        </div>
                                    ) : (
                                        detail.jumpUrl === 'charging' ? (
                                            <Button
                                                className={
                                                    classnames('button-box')
                                                }
                                                onClick={()=>{
                                                    this.appCharging()
                                                }}
                                            >
                                                立即前往
                                            </Button>
                                        ) : (
                                            detail.jumpUrl === 'violations' ?
                                            <Button
                                                className={
                                                    classnames('button-box')
                                                }
                                                onClick={()=>{
                                                    this.appViolations()
                                                }}
                                            >
                                                立即前往
                                            </Button>:''
                                        )
                                    )
                                }
                                
                                <Modal
                                    visible={this.state.modal}
                                    transparent
                                    maskClosable={false}
                                    onClose={()=>{
                                        this.setState({
                                            modal: false,
                                        });
                                    }}
                                    title="确定使用该权益吗"
                                    footer={[
                                            { text: '取消', onPress: () => {
                                                this.setState({
                                                    modal: false,
                                                });}
                                            },
                                            { text: '确定', onPress: () => {
                                                this.applyHcWelfareConsume();
                                            }},
                                        ]}
                                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                                >
                                        <div style={{ color: '#666666', }}>
                                        发起权益后，我们的工作人员审核后会联系您
                                        </div>
                                </Modal>
                            </div>
                            
                        ) :''
                    }
                    
                </div>
            </div>
        );
    }
}

export default InterestsConfig;



// WEBPACK FOOTER //
// ./src/interestsConfig/index.jsx